module.exports = __webpack_public_path__ + "img/cloud-1.f8f628f9.png";